import React, { useEffect, useRef } from 'react'
import './index.less'
import { useStore, effect } from '../../../../dva16'
import { Table, Input, Modal, Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { NUser, EBindWechat, EBindWechatStatus, NPersonal, EWechatQRCode, EBindUserByWechat } from '../../../../models/constants'

function Index() {
  const { userInfo, qrcode } = useStore(NPersonal)
  const interval = useRef(null)

  useEffect(() => {
    console.log('user', userInfo)
    // effect(NUser, EBindWechatStatus)
    if (!userInfo.wechatID) {
      effect(NPersonal, EWechatQRCode)
    }
  }, [userInfo])

  useEffect(() => {
    clearInterval(interval.current)
    interval.current = setInterval(() => {
      console.log('ms', qrcode)
      if (qrcode && qrcode.code) {
        effect(NPersonal, EBindUserByWechat, { code: qrcode.code })
      }
    }, 1000)
    return () => {
      clearInterval(interval.current)
    }
  }, [qrcode])

  const createBindWechat = () => {
    return qrcode ? (
      <div className="bind-wechart">
        <img src={qrcode.url} style={{ width: 190 }}></img>
        <span>请用微信扫码</span>
      </div>
    ) : null
  }
  const createBindInfo = () => {
    return (
      <div className="bind-info">
        <p>已经和微信号({userInfo.wechatID})绑定</p>
        <Button
          onClick={() => {
            Modal.confirm({
              title: `解除绑定`,
              icon: <ExclamationCircleOutlined />,
              content: '确定解除该微信账号绑定',
              okText: '确认',
              cancelText: '取消',
              onOk() {
                effect(NPersonal, EBindUserByWechat, { code: null })
              },
            })
          }}
        >
          取消绑定
        </Button>
      </div>
    )
  }
  return <div id="rqcodeBind">{userInfo.wechatID ? createBindInfo() : createBindWechat()}</div>
}

export default Index
